import React, { useState, useEffect, Suspense, lazy } from 'react';
// Carregar componentes dinamicamente
import MenuPrincipal from "../components/menuPrincipal";
import WhatsApp from "../components/whatsApp";
//fim componentes
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
//Imagens
import elipse from "../assets/imagens/EllipseV5.png";
import celular1 from "../assets/imagens/celular_vendas_2.png";
import celular2 from "../assets/imagens/iphone16_2.png";
import capa_site from "../assets/imagens/capa_site.png";
import logo_google from "../assets/imagens/logo_google.png";
import loja from "../assets/imagens/loja.png";
//configuração do Redux
import { fetchPostsHome } from '../redux/reducers/blogSlice'; // Certifique-se de importar corretamente
import { useDispatch, useSelector } from 'react-redux';
import api from '../redux/actions/configApi';
import { depoimentoSliderSettings, blogSliderSettings } from '../config/sliderConfig'; // Ajuste o caminho conforme necessário
//css
import '../style/home.css';
import '../style/geral.css';
//componentes
const Rodape = lazy(() => import('../components/rodape'));
const BlogSection = lazy(() => import('../components/blogSection'));
const Seo = lazy(() => import('../components/SEO'));
const DepoimentoCarousel = lazy(() => import('../components/DepoimentoCarousel'));

const Home = () => {

  const [depoimentos, setDepoimentos] = useState([]);
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const { posts } = useSelector((state) => state.blog);
  const [rating, setRating] = useState('');
  const [userRatingsTotal, setUserRatingsTotal] = useState('');

  // Função para buscar avaliações da API do Google
  useEffect(() => {
    const fetchGoogleReviews = async () => {
      try {
        const response = await api.get('reviews');
        console.log(response.data, 'resposta');
        setRating(response.data.rating);
        setUserRatingsTotal(response.data.user_ratings_total);

        if (response.data.reviews) {
          setDepoimentos(response.data.reviews);
        } else {
          console.error("Nenhuma avaliação encontrada.");
        }
      } catch (error) {
        console.error("Erro ao buscar avaliações: ", error);
      } finally {
        //setLoading(false);
      }
    };
    fetchGoogleReviews();
  }, []);

  useEffect(() => {
    dispatch(fetchPostsHome(currentPage));
  }, [dispatch, currentPage]);

  useEffect(() => {
    const loadAOS = async () => {
      const AOS = (await import('aos')).default;
      //await import('aos/dist/aos.css');

      AOS.init({
        duration: 2300,
        once: true,
      });
    };

    loadAOS();
  }, []);

  return (
    <div>
      <Suspense >
        <Seo
          title="Venda e Compra de iPhones em Blumenau | Pentalobe"
          description="Venda seu iPhone de forma rápida e segura em Blumenau! Avaliação justa e pagamento imediato. Clique e saiba mais sobre como vender seu iPhone conosco!"
          keywords="iPhone, iPhone novo, iPhone usado, venda de iPhone, melhor preço iPhone, loja iPhone, modelos iPhone, ofertas iPhone, comprar celular, smartphone Apple, loja de celulares, melhores celulares, Blumenau, SC"
          image={capa_site} // Substitua pela imagem de destaque
          url="https://pentalobe.com.br"
          type="website"
        />
      </Suspense>
      {/*{isPixelLoaded && <FacebookPixel pixelId="1886209321611038" />}*/}
      <section className='header-home' id="section1">
        <MenuPrincipal />
        {/*fundos*/}
        {/*elipse computador*/}
        {/* <div className="d-none d-lg-block">
          <img src={elipse} className="elipse" alt="Imagem header" />
        </div>/*
        {/*elipse celular*/}
        <Row className="d-lg-none">
          <Col xs={12} className="d-flex justify-content-center align-items-center">
            <div className='box-celulares-cell-2'>
              <img
                src="/img/celular_vendas_2.png"
                className="img-box-celulares-cell"
                alt="Imagem header"
                loading="eager"
                decoding="async"
                fetchpriority="high"
              />
              <div className='box-home-cel-2'>
                <div className='textos-vendas'>
                  <h3>
                    <span className="linha-1">Venda seu iPhone <br /> de </span>
                    <span className="linha-2">Forma <span className="destaque-titulo">Rápida</span> <br /> e <span className="destaque-titulo">Segura</span></span>
                  </h3>
                </div>
                <div className='botao-vender-cell'>
                  <Button href='/quero-vender' >Quero Vender</Button>
                </div>
              </div>
            </div>
          </Col>
          <Col xs={12} className='d-flex justify-content-center align-items-end'>
            <div className='box-celulares-cell' >
              <div className='box-home-cel'>
                <div className='textos-compra'>
                  <h3>
                    <span className="linha-1"> Compre iPhones <br /> Novos e </span>
                    <span className="linha-2"><span className="destaque-titulo">Usados</span>  <br /> com <span className="destaque-titulo">Garantia</span></span>
                  </h3>
                </div>
                <div className='botao-comprar-cell'>
                  <Button href='/quero-comprar'>Quero Comprar</Button>
                </div>
              </div>
              <img
                src="/img/iphone16_2.png"
                className="img-box-celulares-cell"
                alt="Imagem header"
                loading="eager"
                decoding="async"
                fetchpriority="high"
              />
              <picture>
                <source srcSet="/img/EllipseCelular.webp" type="image/webp" />
                <img src="/img/EllipseCelular.png" className="elipseCelular" alt="Imagem header" loading="eager" />
              </picture>
            </div>
          </Col>
        </Row>
        {/*Desktop*/}
        <Row className="d-none d-lg-flex">
          <Col lg={6} style={{ position: 'relative' }} className='altura-tela'>
            <div className='box-celulares-1'>
              <img data-aos="fade-right" src={celular1} className='img-box-celulares-pc img-fluid' alt="celular header" />
              <div className='box-home-1'>
                <div className="textos-vendas">
                  <h3 data-aos="fade-up">
                    <span className="linha-1">Venda seu iPhone de</span><br />
                    <span className="linha-2">Forma <span className="destaque-titulo">Rápida</span> e <span className="destaque-titulo">Segura</span></span>
                  </h3>
                </div>
                <div className='botao-vender' data-aos="fade-up">
                  <Button href='/quero-vender'>Quero Vender</Button>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={6} >
            <div className='box-celulares-2'>
              <div className='box-home-1'>
                <div className='textos-compra'>
                  <h3 data-aos="fade-up">
                    <span className="linha-1"> Compre iPhones Novos e</span><br />
                    <span className="linha-2"><span className="destaque-titulo">Usados</span> com <span className="destaque-titulo">Garantia</span></span>
                  </h3>
                </div>
                <div className='botao-comprar' data-aos="fade-up">
                  <Button href='/quero-comprar' >Quero Comprar</Button>
                </div>
              </div>
              <img src={celular2} className='img-box-celulares-pc img-fluid' data-aos="fade-left" alt="Imagem header" />
            </div>
            <div className="">
              <img src={elipse} className="elipse" alt="Imagem header" />
            </div>
          </Col>
        </Row>
        {/*inicio celulares vender*/}
        {/*<div className="d-md-none">
        
        </div>*/}
        {/*inicio celulares comprar*/}
        {/*<div className="d-md-none">
         
        </div>*/}
        {/*fim celulares*/}
      </section>
      {/******************Sobre */}
      <section className='sobre section-spacing' >
        <Row>
          <Col md={12} xs={12} className="section-title">

            <div className="titulo-degradado" data-aos="fade-up">
              <h1>A empresa </h1>
            </div>

            <div className="borda"></div>
          </Col>
        </Row>
        <Row>
          <Col md={6} xs={12} className="d-flex align-items-center justify-content-center">
            <img data-aos="fade-right" src={loja} className='imagem-loja' alt="Imagem Loja" />
          </Col>
          <Col md={6} xs={12} className="d-flex align-items-center justify-content-center">
            <div className='box-texto-sobre' data-aos="fade-left">
              <p>"A Pentalobe é uma empresa IRP credenciada Apple, contamos com assistência técnica certificada, e também com venda de toda a linha de produtos Apple novos, semi-novos e acessórios originais, todos com emissão de certificado de diagnóstico Apple aprovado, e com 1 Ano de Garantia. Atuamos em Blumenau - SC desde 2013, sempre com a qualidade que você merece!"
              </p>
            </div>
          </Col>
        </Row>
      </section>
      <section className='depoimentos section-spacing'>
        <Row>
          <Col md={12} xs={12} >
            <div data-aos="fade-up" className="section-title ">
              <h1 >O que dizem nossos clientes no</h1>
              <img className='logo-google-titulo' alt="logo_google" src={logo_google}></img>
              <div className="borda"></div>
            </div>
          </Col>
        </Row>
        <div className='box-depoimentos' data-aos="fade-right" data-aos-offset="300" data-aos-easing="ease-in-sine">
          <Suspense fallback={<div>Carregando depoimentos...</div>}>
            <DepoimentoCarousel
              depoimentos={depoimentos}
              settings={depoimentoSliderSettings}
              rating={rating}
              userRatingsTotal={userRatingsTotal}
            />
          </Suspense>
        </div>
      </section>
      <section className='blog section-spacing' >
        <Suspense>
          <BlogSection title="Blog" articles={posts?.data} settings={blogSliderSettings} titulo={'Blog'} size={'card-config'} link={1} disableAnimation={true} />
        </Suspense>
      </section>
      <Suspense>
        <Rodape />
      </Suspense>
      {/* Botão Fixo do WhatsApp */}
      <WhatsApp classe={'whatsapp-componente-flutuante'}/>
      
    </div >
  );
};

export default Home;
